module.exports = __webpack_public_path__ + "static/media/keypoints-white.a27825f7.svg";